import { peek, selector } from 'lib/selectors'
import { StateInterface } from 'types/state'

const guest = (state: StateInterface) => state.guest
export const jobsGuestSelector = selector(guest, peek('jobsList'))
export const jobsMetaGuestSelector = selector(guest, peek('jobsListMeta'))
